import { useLayoutEffect, useRef } from "react";

const GAP = 16;
const MIN = 420;

const bottomChromeTop = () => {
  const limit = window.innerHeight;
  let top = limit;
  document.querySelectorAll("body *").forEach((el) => {
    const style = window.getComputedStyle(el);
    if (style.position !== "fixed" || style.display === "none" || style.visibility === "hidden") return;
    const rect = el.getBoundingClientRect();
    if (rect.height && rect.top > limit / 2 && rect.top < limit && rect.width > window.innerWidth / 2) {
      top = Math.min(top, rect.top);
    }
  });
  return top;
};

const useFitHeight = () => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    let frame = 0;
    const fit = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const top = el.getBoundingClientRect().top + window.scrollY;
        const height = Math.max(MIN, Math.floor(bottomChromeTop() - top - GAP));
        el.style.height = `${height}px`;
      });
    };
    fit();
    window.addEventListener("resize", fit);
    const observer = typeof ResizeObserver === "function" ? new ResizeObserver(fit) : null;
    observer?.observe(document.body);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", fit);
      observer?.disconnect();
    };
  }, []);
  return ref;
};

export default useFitHeight;
